import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import Button from "@material-ui/core/Button";
import React from "react";
import PipeCard from "../../../pipe-common/PipeCard";
import UseSpellmanIcaControl from "./hooks/UseSpellmanIcaControl";

export default function SpellmanIcaControl({pipe, handleSettingsChanged, handleSettingsApply, handleActionsApply}) {
    const {
        settings,
        applying,
        hasErrors,
        validationErrors,
        handleHeaterGridEnablesChanged,
        handleArcFaultProgramChanged,
        handleMeanCathodeOverCurrentChanged,
        handleGridPulsedVoltageChanged,
        handleCathodeVoltageChanged,
        handleHeaterVoltageChanged,
        handleApplyClick,
        handleResetFaultsClick,
        handleResetArcCounterClick
    } = UseSpellmanIcaControl({
        pipe,
        onChanged: handleSettingsChanged,
        onApply: handleSettingsApply,
        onActions: handleActionsApply
    });

    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Grid container direction={"column"} alignItems={"center"} spacing={2}>
                    <Grid item xs={12}>
                        <FormControl>
                            <FormGroup row>
                                <FormControlLabel
                                    value="heater_grid_enables"
                                    control={
                                        <Switch checked={settings.heaterGridEnables}
                                                onChange={(e) =>
                                                    handleHeaterGridEnablesChanged(e.target.checked)}
                                        />
                                    }
                                    label={
                                        <Typography style={{fontSize: "0.9rem"}}>
                                            Heater Grid Enables
                                        </Typography>
                                    }
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} container direction={"row"} justify={"center"} spacing={2}>
                        <Grid item>
                            <TextField
                                id="arc_fault_program"
                                type={"number"}
                                label={
                                    <Grid container justify={"flex-start"} spacing={1}>
                                        <Grid item xs>
                                            <Typography>Arc Fault Program</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Tooltip title="Range: (1-250)">
                                                <HelpIcon fontSize={"small"}/>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                }
                                value={settings.arcFaultProgram}
                                error={validationErrors["arc_fault_program"]}
                                inputProps={{
                                    step: 1,
                                    style: {textAlign: "center"}
                                }}
                                onChange={(e) =>
                                    handleArcFaultProgramChanged(e.target.value)}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="mean_cathode_over_current"
                                type={"number"}
                                label="Mean Cathode Over Current mA (0-10)"
                                value={settings.meanCathodeOverCurrent}
                                error={validationErrors["mean_cathode_over_current"]}
                                inputProps={{
                                    step: 0.1,
                                    style: {textAlign: "center"}
                                }}
                                onChange={(e) =>
                                    handleMeanCathodeOverCurrentChanged(e.target.value)}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="grid_pulsed_voltage"
                                type={"number"}
                                label="Grid Pulsed Voltage V (0-15)"
                                value={settings.gridPulsedVoltage}
                                error={validationErrors["grid_pulsed_voltage"]}
                                inputProps={{
                                    step: 0.1,
                                    style: {textAlign: "center"}
                                }}
                                onChange={(e) =>
                                    handleGridPulsedVoltageChanged(e.target.value)}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="cathode_voltage"
                                type={"number"}
                                label="Cathode Voltage kV (0-15)"
                                value={settings.cathodeVoltage}
                                error={validationErrors["cathode_voltage"]}
                                inputProps={{
                                    step: 0.1,
                                    style: {textAlign: "center"}
                                }}
                                onChange={(e) =>
                                    handleCathodeVoltageChanged(e.target.value)}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="heater_voltage"
                                type={"number"}
                                label="Heater Voltage V (0-6.5)"
                                value={settings.heaterVoltage}
                                error={validationErrors["heater_voltage"]}
                                inputProps={{
                                    step: 0.1,
                                    style: {textAlign: "center"}
                                }}
                                onChange={(e) =>
                                    handleHeaterVoltageChanged(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            }
            bottom={
                <Grid container direction={"row"} justify={"center"} spacing={2}>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                disabled={applying || hasErrors}
                                onClick={handleApplyClick}
                        >
                            Apply
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                disabled={applying}
                                onClick={handleResetFaultsClick}
                        >
                            Reset Faults
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                disabled={applying}
                                onClick={handleResetArcCounterClick}
                        >
                            Reset Arc Counter
                        </Button>
                    </Grid>
                </Grid>
            }
        />
    );
}